import $ from "jquery";
import whatInput from "what-input";

import Foundation from "foundation-sites/dist/js/foundation";

// Bye slick
//import slick from "./vendor/slick.min.js";

window.$ = $;

Foundation.addToJquery($);


import "./blocks/carousel-block.js";
import "./blocks/coalition-members-block.js";
import "./blocks/home-title-callouts.js";


/* Turn on when a foundation component ends up being used such as accordions etc... */
$(document).foundation();
